<script setup lang="ts">
import router from '@/router'
import { useUserInfoStore } from '@/stores/modules/user'
import { ref, computed } from 'vue'
import { useRoute } from 'vue-router'

const userInfo = useUserInfoStore()
const route = useRoute()
const defaultActive = ref(route.path)

// 硬编码加热炉菜单（对标web-admin-ui.html）
const menuGroups = [
  {
    title: '监控中心',
    items: [
      { icon: '📊', path: '/heating-dashboard', label: '数据大屏' },
      { icon: '🏭', path: '/heating/devices', label: '设备管理' },
      { icon: '📈', path: '/heating/realtime', label: '实时监控' },
      { icon: '🔔', path: '/heating/alarms', label: '报警中心', badge: 3 }
    ]
  },
  {
    title: '出厂管理',
    items: [
      { icon: '📦', path: '/heating/registry', label: '出厂登记' },
      { icon: '🏢', path: '/heating/customers', label: '客户管理' }
    ]
  },
  {
    title: '数据分析',
    items: [
      { icon: '📉', path: '/heating/history', label: '历史数据' },
      { icon: '📋', path: '/heating/upload-history', label: '数据查看' },
      { icon: '📑', path: '/heating/report', label: '数据报表' },
      { icon: '⚡', path: '/heating/energy', label: '能耗分析' }
    ]
  },
  {
    title: '系统管理',
    items: [
      { icon: '👥', path: '/heating/settings', label: '设备参数' },
      { icon: '📝', path: '/heating/logs', label: '操作日志' }
    ]
  }
]

// 所有菜单项（用于判断active）
const allItems = computed(() => menuGroups.flatMap(g => g.items))

const handleSelect = (path: string) => {
  router.push(path)
}

// 判断是否active
const isActive = (path: string) => {
  return route.path === path
}
</script>

<template>
  <div class="sidebar-menu" :class="{ collapsed: userInfo.collapse }">
    <div class="menu-scroll">
      <div v-for="group in menuGroups" :key="group.title" class="menu-group">
        <div v-if="!userInfo.collapse" class="group-title">{{ group.title }}</div>
        <div
          v-for="item in group.items"
          :key="item.path"
          class="menu-item"
          :class="{ active: isActive(item.path) }"
          @click="handleSelect(item.path)"
        >
          <span class="menu-icon">{{ item.icon }}</span>
          <span v-if="!userInfo.collapse" class="menu-label">{{ item.label }}</span>
          <span v-if="item.badge && !userInfo.collapse" class="menu-badge">{{ item.badge }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.sidebar-menu {
  @apply flex flex-col flex-1 overflow-hidden;
  background: #1E293B;
}

.menu-scroll {
  @apply flex-1 overflow-y-auto py-2;
}

.menu-group {
  @apply mb-2;
}

.group-title {
  @apply px-6 pt-3 pb-1;
  font-size: 11px;
  color: rgba(148, 163, 184, 0.6);
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 600;
}

.menu-item {
  @apply flex items-center mx-2 px-4 py-2.5 rounded-lg cursor-pointer transition-all;
  font-size: 14px;
  color: rgba(203, 213, 225, 0.85);
  margin-bottom: 2px;
  position: relative;

  &:hover {
    background: rgba(148, 163, 184, 0.1);
    color: #fff;
  }

  &.active {
    background: rgba(59, 130, 246, 0.2);
    color: #fff;
    font-weight: 500;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 6px;
      bottom: 6px;
      width: 3px;
      border-radius: 0 3px 3px 0;
      background: #60A5FA;
    }
  }
}

.menu-icon {
  @apply flex-shrink-0;
  width: 20px;
  font-size: 16px;
  margin-right: 12px;
  text-align: center;
}

.menu-label {
  @apply flex-1;
}

.menu-badge {
  @apply flex-shrink-0;
  background: #EF4444;
  color: white;
  font-size: 10px;
  padding: 2px 8px;
  border-radius: 10px;
  font-weight: 600;
}

.collapsed {
  .menu-icon {
    margin-right: 0;
  }
}
</style>
